
























import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { PrivateWorker } from '@/types/user'
import InviteWorkerModal from '@/components/manageTeam/InviteWorkerModal.vue'
import { PatientListItem } from '@/components/manageOrganization/PatientSearchField.vue'

@Component({
  components: {
    InviteWorkerModal,
    TeamMemberSearch: () =>
      import('@/components/manageOrganization/TeamMemberSearch.vue'),
    WorkerSearch: () =>
      import('@/components/manageOrganization/WorkerSearch.vue')
  }
})
export default class ManageOrganization extends Vue {
  $store!: ExStore
  modalShow = false
  currentPatient: PatientListItem | null = null

  get myWorkerInfo() {
    return this.$store.getters['user/workerInfo'] as PrivateWorker
  }

  handleInviteMember() {
    if (!this.currentPatient) {
      return
    }
    this.modalShow = true
  }

  handleSelectPatient(patient: PatientListItem) {
    this.currentPatient = patient
  }

  async created() {
    await Promise.all([
      this.$store.dispatch('user/updateWorkerInfo'),
      this.$store.dispatch('occupation/fetch')
    ])
  }
}
